import * as React from 'react';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import { toast } from 'react-toastify';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Zoom from '@mui/material/Zoom';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import EnhancedDataGrid from '../Common/EnhancedDataGrid'; import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import { isNewUi } from '../../redesign/uiMode';
import { LOOKUP_CANCEL, lookupDialogProps } from '../../redesign/shell/lookupCancel';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Zoom in={true} ref={ref} {...props} />;
});

export class Level3Lookup extends React.Component {
	constructor(props) {
		super(props);

		this.level2Key = null;
		this.poCode = null;

		this.inProgress = false;

		this.state = {
			level3Key: null,
			data: [],
			rowData: null
		};
		this.refresh_clickHandler = this.refresh_clickHandler.bind(this);
		this.checkbox_clickHandler = this.checkbox_clickHandler.bind(this);
		this.close_clickHandler = this.close_clickHandler.bind(this);
		this.cancel_clickHandler = this.cancel_clickHandler.bind(this);
	}

	componentDidUpdate() {
		var that = this;

		if (this.props.info.level2Key !== this.level2Key || this.props.info.poCode !== this.poCode) {
			this.level2Key = this.props.info.level2Key;
			this.poCode = this.props.info.poCode;

			this.inProgress = false;
			this.setState({ data: [], rowData: null });
		}

		if (this.props.info.refreshKey !== this.refreshKey) {
			this.refreshKey = this.props.info.refreshKey;

			this.inProgress = false;
			this.setState({ data: [], rowData: null });
		}

		if (this.props.info.openDialog && this.state.data.length === 0 && !this.inProgress) {
			this.inProgress = true;
			this.fetchRecords();
		}
		else if (this.props.info.level3Key !== this.state.level3Key) {
			var rowData = this.getRowData(this.props.info.level3Key);

			this.setState({ level3Key: this.props.info.level3Key, rowData: rowData });
		}
	}
	getRefreshButton = () => {
		return <IconButton
			variant="contained"
			onClick={this.refresh_clickHandler}
			size="small"
			style={{ float: "right", zIndex: 1, marginTop: 10, display: 'none' }}>
			<RefreshIcon />
		</IconButton>;
	}

	refresh_clickHandler(event) {
		this.props.info.inProgress(true);
		let functionName = "getlevel3";
		let messageName = "Level 3";
		httpGet("/api/Adapter/getSyncData/" + functionName)
			.then(response => {
				var data = response.data;
				this.props.info.inProgress(false);
				if (data)
					toast.success(messageName + ' Fetched Successfully');
				else
					toast.error('Error fetching ' + messageName);

			}).catch((error) => {
				this.props.info.inProgress(false);
				toast.error('Error fetching ' + messageName);
			});
	}
	checkbox_clickHandler = (event) => {
		const clickedValue = event.target.value;
		const clickedRow = this.getRowData(clickedValue);

		if (!clickedRow) return;

		const isSameSelected =
			this.state.rowData &&
			this.state.rowData.level3Key === clickedRow.level3Key;

		this.setState({
			rowData: isSameSelected ? null : clickedRow 
		});
	};


	close_clickHandler(event) {
		if (this.props.onClose) {
			this.props.onClose(event, this.state.rowData);
		}
	}

	fetchRecords() {
		if (this.state.data.length === 0) {

			this.props.info.inProgress(true);

			httpGet("/api/lookup/level3list?level2Key=" + encodeURIComponent(this.props.info.level2Key) + "&poCode=" + encodeURIComponent(this.props.info.poCode))
				.then((response) => {
					//var data = response.data;
					var data = response.data.map((e, i) => { let d = { ...e, rowId: i }; return d; })
					var rowData = data[data.findIndex(d => d.level3Key === this.props.info.level3Key)];
					this.setState({ level3Key: this.props.info.level3Key, data: data, rowData: rowData });
					this.props.info.inProgress(false);
				}).catch((error) => {
					this.props.info.inProgress(false);

					toast.error('Error fetching Activity Lookup');

					this.close_clickHandler();
				});
		}
	}

	getRowData(value) {
		var data = this.state.data;

		return data[data.findIndex(d => d.level3Key === value)];
	}

	// New UI: close without applying (Cancel, ✕ and Escape).
	cancel_clickHandler(event) {
		if (this.props.onClose) {
			this.props.onClose(event, LOOKUP_CANCEL);
		}
	}

	render() {
		const newUi = isNewUi();
		const cellStyle = { paddingLeft: 8, paddingRight: 28 };
		const headerStyle = { textAlign: 'right' };

		return (
			<Dialog open={this.props.info.openDialog} TransitionComponent={Transition} fullWidth maxWidth="lg" {...lookupDialogProps(newUi)}>
				<DialogTitle>
					Select Activity
						</DialogTitle>
				<DialogContent>
					<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
						<EnhancedDataGrid rows={this.state.data}
							disableColumnMenu
							pagination
							pageSize={10}
							customcomponent={this.getRefreshButton()}
							columns={[
								{
									headerName: ' ',
									field:'chkLevel3',
									width: 40,
									renderCell: rowData =>
										<Checkbox
											color="default"
											name="chk"
											checked={this.state.rowData != null && this.state.rowData !== undefined && rowData.row.level3Key === this.state.rowData.level3Key}
											value={rowData.row.level3Key}
											onClick={this.checkbox_clickHandler}
										/>
									
								},
								{
									headerName: 'Activity',
									field: 'level3Key',
									width: 50,
									flex: 1
								},
								{
									headerName: 'Description',
									field: 'level3Description',
									flex: 1
								},
								{
									headerName: 'Open Date',
									field: 'openDate',
									type: 'date',
									valueGetter: ({ value }) => (value && new Date(value)),
									flex: 1
								},
								{
									headerName: 'Cost Type',
									field: 'costType',
									width: 50,
									flex: 1
								},
								{
									headerName: 'Customer PO Number',
									field: 'customerPONumber',
									width: 50,
									flex: 1
								}

							]}
							getRowId={(row) => row.rowId}
							disableSelectionOnClick
						/>
					</div>
				</DialogContent>
				<DialogActions>
					{newUi ? <Button onClick={this.cancel_clickHandler} data-apw2-dismiss="true">Cancel</Button> : null}
					<Button autoFocus onClick={this.close_clickHandler} color="primary">
						{newUi && this.state.rowData ? 'Select' : 'Close'}
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}
